// Appends the Ada chatbot script into the document body.
(function () {

    var isLowerEnv = ((window.location.host.indexOf("uat.bestegg") > -1) || (window.location.host.indexOf("localhost") > -1));
    var dataHandle;
  
    // Environment check to set data handle
    if (isLowerEnv) {
      dataHandle = 'bestegg';
    }
    else {
      dataHandle = 'bestegg-prod';
    }
  
    var scriptsLocation = document.getElementsByTagName('script')[0];
    var adaScript = document.createElement('script');
    var src = 'https://static.ada.support/embed2.js';
  
    // The "data-lazy" attribute  will prevent the bot from loading until the
    // adaEmbed.start(...) method is called.
    var adaLazyAttribute = document.createAttribute("data-lazy");
    
    // Ada chatbot script attributes
    adaScript.setAttributeNode(adaLazyAttribute);
    // adaScript.setAttributeNode(adaAsyncAttribute);
    adaScript.id = "__ada";
    adaScript.setAttribute("data-handle", dataHandle);
    adaScript.src = src;
    scriptsLocation.parentNode.insertBefore(adaScript, scriptsLocation);
  })();